function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var Transaction = require('../../../lib/saito/transaction')["default"];

// Confirmed tweets newer than this are treated as live inserts. They must not
// advance tweets_local_synced_ts, or a single new post would imply the entire
// historical local archive is a reliable feed source.
var LIVE_TWEET_WINDOW_MS = 5 * 60 * 1000;
var PEER_REQUEST_TIMEOUT_MS = 12000;
var MAX_POLL_PAGES = 5;
var MAX_ARCHIVE_PAGE_SIZE = 100;
function isLocalPeer(peer_obj) {
  return (peer_obj === null || peer_obj === void 0 ? void 0 : peer_obj.peer) === 'localhost';
}
function remotePeers(mod) {
  return (mod.peers || []).filter(function (peer_obj) {
    return !isLocalPeer(peer_obj);
  });
}
function localPeer(mod) {
  return (mod.peers || []).find(function (peer_obj) {
    return isLocalPeer(peer_obj);
  }) || null;
}
function createPeerState(peer, publicKey) {
  return {
    peer: peer,
    publicKey: publicKey || '',
    tweets_earliest_ts: Date.now(),
    tweets_exhausted: false,
    tweets_has_rows: false,
    tweets_history_version: 0,
    tweets_latest_ts: 0,
    tweets_limit: 10,
    tweets_hydrated: false
  };
}

// History may have gained rows above the old cursor. Revisit the recent end;
// signature deduplication keeps already cached tweets from being added twice.
function reopenTweetSource(peer_obj) {
  peer_obj.tweets_exhausted = false;
  peer_obj.tweets_earliest_ts = Date.now();
  peer_obj.tweets_history_version = (peer_obj.tweets_history_version || 0) + 1;
}
function hasUsableTimelineContent(mod) {
  return (mod.tweets_timeline || []).length > 0;
}
function newestKnownTweetTs(mod) {
  return (mod.tweets_timeline || []).reduce(function (latest, signature) {
    var _mod$getTweet;
    var tweet = (_mod$getTweet = mod.getTweet) === null || _mod$getTweet === void 0 ? void 0 : _mod$getTweet.call(mod, signature);
    return Math.max(latest, Number(tweet === null || tweet === void 0 ? void 0 : tweet.created_at) || 0);
  }, 0);
}

//
// tweets_local_synced_ts is the newest created_at through which locally archived
// content can reasonably be relied on as a feed source. It is not a viewed
// cursor, not updated_at, and not "the newest tweet the user just posted."
//
// Only blockchain-confirmed tweets that are already older than LIVE_TWEET_WINDOW_MS
// move the frontier forward. Historical sync therefore advances it as old blocks
// land; a live tweet at "now" does not claim that every earlier hole is filled.
//
function noteLocalSyncedTweet(mod, created_at, blk) {
  var _mod$saveOptions;
  if (!blk) {
    return false;
  }
  var ts = Number(created_at) || 0;
  if (ts <= 0) {
    return false;
  }
  if (Date.now() - ts < LIVE_TWEET_WINDOW_MS) {
    return false;
  }
  var current = Number(mod.tweets_local_synced_ts) || 0;
  if (ts <= current) {
    return false;
  }
  mod.tweets_local_synced_ts = ts;
  (_mod$saveOptions = mod.saveOptions) === null || _mod$saveOptions === void 0 || _mod$saveOptions.call(mod);
  return true;
}

//
// Decide which peers to query. Manager does not call this; loadTransactions does.
//
// newer + unhydrated remotes → remote tip (created_earlier_than now).
// newer + hydrated remotes   → poll (updated_later_than).
// newer + no remotes         → localhost tip/poll as fallback.
// older                      → remotes still walking backward; localhost joins
//                              only once demand has reached the local frontier.
//
function isExactLookup(mode) {
  return mode === 'local' || mode === 'remote' || mode === 'all';
}
function selectTweetSources(mod, mode) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var remotes = remotePeers(mod);
  var local = localPeer(mod);
  var frontier = Number(mod.tweets_local_synced_ts) || 0;
  var demand_ts = Number(options.demand_ts) || 0;

  // Exact signature lookup is a different operation from chronological
  // newer/older paging. It never consults the local frontier or peer cursors.
  if (isExactLookup(mode)) {
    var _peers = [];
    if (mode !== 'remote' && local) {
      _peers.push(local);
    }
    if (mode !== 'local') {
      var _iterator = _createForOfIteratorHelper(remotes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var peer_obj = _step.value;
          _peers.push(peer_obj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return {
      mode: mode,
      peers: _peers,
      demand_ts: demand_ts,
      frontier: frontier,
      lookup: true
    };
  }
  if (mode === 'older') {
    var _peers2 = [];
    var _iterator2 = _createForOfIteratorHelper(remotes),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _peer_obj = _step2.value;
        if (!_peer_obj.tweets_exhausted) {
          _peers2.push(_peer_obj);
        }
      }

      // Demand is the oldest currently rendered root. Once that timestamp is at
      // or below the durable local frontier, localhost is an additional source —
      // not a replacement for remote. An unknown frontier (0) still includes
      // local on older fetches so scrolling can use the archive, without ever
      // making init local-first.
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var demandReachedLocal = demand_ts > 0 && (frontier <= 0 || demand_ts <= frontier);
    if (local && !local.tweets_exhausted && (demandReachedLocal || _peers2.length === 0)) {
      _peers2.push(local);
    }
    return {
      mode: 'older',
      peers: _peers2,
      demand_ts: demand_ts,
      frontier: frontier
    };
  }
  var unhydratedRemotes = remotes.filter(function (peer_obj) {
    return !peer_obj.tweets_hydrated;
  });
  var hydratedRemotes = remotes.filter(function (peer_obj) {
    return peer_obj.tweets_hydrated;
  });
  if (remotes.length === 0) {
    if (!local) {
      return {
        mode: 'tip',
        peers: [],
        demand_ts: demand_ts,
        frontier: frontier
      };
    }
    return {
      mode: local.tweets_hydrated ? 'poll' : 'tip',
      peers: [local],
      demand_ts: demand_ts,
      frontier: frontier
    };
  }

  // Prefer remotes for the initial feed. Localhost is excluded until it is
  // already hydrated (poll) or until a remote tip produced nothing (fallback).
  var peers = unhydratedRemotes.concat(hydratedRemotes);
  if (local && local.tweets_hydrated) {
    peers.push(local);
  }
  return {
    mode: unhydratedRemotes.length && !hydratedRemotes.length ? 'tip' : 'poll',
    peers: peers,
    demand_ts: demand_ts,
    frontier: frontier
  };
}
function queryTypeForPeer(peer_obj, mode) {
  if (isExactLookup(mode)) {
    return 'lookup';
  }
  if (mode === 'older') {
    return 'older';
  }
  if (!peer_obj.tweets_hydrated) {
    return 'tip';
  }
  return 'poll';
}
function emptyResult(type, direction) {
  return {
    type: type,
    direction: direction,
    added: [],
    new_tweets: [],
    updated: [],
    ignored: [],
    failed: false,
    history_reopened: false,
    exhausted: true
  };
}
function processTweetTxs(mod, peer_obj, txs, _ref) {
  var updateEarliest = _ref.updateEarliest,
    updatePeerCursors = _ref.updatePeerCursors,
    _ref$updateLatest = _ref.updateLatest,
    updateLatest = _ref$updateLatest === void 0 ? updatePeerCursors : _ref$updateLatest,
    notify = _ref.notify,
    newest_known_tweet_ts = _ref.newest_known_tweet_ts,
    includeNew = _ref.includeNew;
  var added = [];
  var new_tweets = [];
  var updated = [];
  var ignored = [];
  for (var i = 0; i < (txs || []).length; i++) {
    var _working$optional;
    var tx = txs[i];
    if (!tx) {
      continue;
    }
    var working = typeof tx.toJson === 'function' ? new Transaction(undefined, tx.toJson()) : tx;
    if (!working) {
      continue;
    }
    if (working !== tx) {
      working.optional = tx.optional && _typeof(tx.optional) === 'object' ? _objectSpread({}, tx.optional) : {};
    }
    if (typeof working.decryptMessage === 'function') {
      working.decryptMessage(mod.app);
    }
    var signature = working.signature != null ? String(working.signature) : '';
    if (!signature) {
      continue;
    }
    var created_at = Number(working.timestamp) || Number(tx.timestamp) || Date.now();
    var updated_at = Number((_working$optional = working.optional) === null || _working$optional === void 0 ? void 0 : _working$optional.updated_at) || created_at;
    var hadTweet = mod.hasTweet(signature);
    var tweet = mod.addTweet(working);
    if (!tweet) {
      if (!ignored.includes(signature)) {
        ignored.push(signature);
      }
    } else if (!hadTweet) {
      var _mod$app;
      if (!added.includes(signature)) {
        added.push(signature);
      }
      if (notify && (_mod$app = mod.app) !== null && _mod$app !== void 0 && _mod$app.BROWSER) {
        var _mod$addNotification;
        (_mod$addNotification = mod.addNotification) === null || _mod$addNotification === void 0 || _mod$addNotification.call(mod, working);
      }
      if (includeNew && created_at > newest_known_tweet_ts && !new_tweets.includes(signature)) {
        new_tweets.push(signature);
      }
    } else if (!updated.includes(signature)) {
      updated.push(signature);
    }
    if (updatePeerCursors && updateEarliest && created_at < peer_obj.tweets_earliest_ts) {
      peer_obj.tweets_earliest_ts = created_at;
    }
    if (updateLatest && updated_at > peer_obj.tweets_latest_ts) {
      peer_obj.tweets_latest_ts = updated_at;
    }
  }
  return {
    added: added,
    new_tweets: new_tweets,
    updated: updated,
    ignored: ignored
  };
}
function queryPeer(mod, peer_obj, queryType, options) {
  return new Promise(function (resolve) {
    var _peer_obj$peer;
    var settled = false;
    var finish = function finish(txs) {
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (settled) {
        return;
      }
      settled = true;
      clearTimeout(timer);
      resolve({
        txs: txs,
        failed: failed
      });
    };
    var timer = setTimeout(function () {
      return finish([], true);
    }, PEER_REQUEST_TIMEOUT_MS);
    var customRequest = queryType === 'older' && !isLocalPeer(peer_obj) && ((_peer_obj$peer = peer_obj.peer) === null || _peer_obj$peer === void 0 ? void 0 : _peer_obj$peer.publicKey);
    var receive = function receive(rows) {
      // A timed-out request must not deserialize or ingest a late response.
      if (settled) {
        return;
      }
      try {
        if (!Array.isArray(rows)) {
          throw new Error('Invalid tweet response');
        }
        var txs = customRequest ? rows.map(function (row) {
          var tx = new Transaction();
          tx.deserialize_from_web(mod.app, row);
          return tx;
        }) : rows;
        finish(txs);
      } catch (err) {
        finish([], true);
      }
    };
    try {
      var request;
      if (customRequest) {
        request = mod.app.network.sendRequestAsTransaction('load tweets', {
          created_earlier_than: peer_obj.tweets_earliest_ts,
          field4: ''
        }, receive, peer_obj.peer.publicKey);
      } else {
        var obj = queryType === 'lookup' ? {
          sig: String(options.sig),
          field1: 'RedSquare',
          flagged_ne: 1,
          limit: 1
        } : {
          field1: 'RedSquare',
          flagged_ne: 1,
          field4: '',
          limit: peer_obj.tweets_limit || 10
        };
        if (queryType === 'older' || queryType === 'tip') {
          obj.created_earlier_than = queryType === 'tip' ? Date.now() : peer_obj.tweets_earliest_ts;
        } else if (queryType === 'poll') {
          var _options$pollAfter, _ref2, _options$pollLimit;
          obj.updated_later_than = (_options$pollAfter = options.pollAfter) !== null && _options$pollAfter !== void 0 ? _options$pollAfter : peer_obj.tweets_latest_ts;
          obj.ascending = true;
          obj.limit = (_ref2 = (_options$pollLimit = options.pollLimit) !== null && _options$pollLimit !== void 0 ? _options$pollLimit : peer_obj.tweets_limit) !== null && _ref2 !== void 0 ? _ref2 : 10;
        }
        var archivePeer = isLocalPeer(peer_obj) ? 'localhost' : peer_obj.peer;
        request = mod.app.storage.loadTransactions(obj, receive, archivePeer);
      }
      Promise.resolve(request)["catch"](function () {
        return finish([], true);
      });
    } catch (err) {
      finish([], true);
    }
  });
}
function queryPollPages(_x, _x2, _x3) {
  return _queryPollPages.apply(this, arguments);
}
function _queryPollPages() {
  _queryPollPages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(mod, peer_obj, options) {
    var baseLimit, historyVersion, limit, after, transactions, page, response, latest, _iterator8, _step8, _tx$optional, tx, signature, updatedAt, safeAfter, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          baseLimit = Math.min(MAX_ARCHIVE_PAGE_SIZE, Math.max(10, Math.floor(Number(peer_obj.tweets_limit) || 10)));
          historyVersion = peer_obj.tweets_history_version || 0;
          limit = baseLimit;
          after = Number(peer_obj.tweets_latest_ts) || 0;
          transactions = new Map();
          page = 0;
        case 1:
          if (!(page < MAX_POLL_PAGES)) {
            _context.n = 18;
            break;
          }
          if (!((peer_obj.tweets_history_version || 0) !== historyVersion)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, {
            txs: [],
            failed: true
          });
        case 2:
          _context.n = 3;
          return queryPeer(mod, peer_obj, 'poll', _objectSpread(_objectSpread({}, options), {}, {
            pollAfter: after,
            pollLimit: limit
          }));
        case 3:
          response = _context.v;
          if (!response.failed) {
            _context.n = 4;
            break;
          }
          return _context.a(2, response);
        case 4:
          if (!(response.txs.length > limit)) {
            _context.n = 5;
            break;
          }
          return _context.a(2, {
            txs: [],
            failed: true
          });
        case 5:
          latest = after;
          _iterator8 = _createForOfIteratorHelper(response.txs);
          _context.p = 6;
          _iterator8.s();
        case 7:
          if ((_step8 = _iterator8.n()).done) {
            _context.n = 10;
            break;
          }
          tx = _step8.value;
          signature = String((tx === null || tx === void 0 ? void 0 : tx.signature) || '');
          updatedAt = Number(tx === null || tx === void 0 || (_tx$optional = tx.optional) === null || _tx$optional === void 0 ? void 0 : _tx$optional.updated_at) || Number(tx === null || tx === void 0 ? void 0 : tx.timestamp); // Reject invalid/non-ascending results instead of advancing past unseen rows.
          if (!(!signature || !Number.isSafeInteger(updatedAt) || updatedAt <= after || updatedAt < latest)) {
            _context.n = 8;
            break;
          }
          return _context.a(2, {
            txs: [],
            failed: true
          });
        case 8:
          latest = updatedAt;
          transactions.set(signature, tx);
        case 9:
          _context.n = 7;
          break;
        case 10:
          _context.n = 12;
          break;
        case 11:
          _context.p = 11;
          _t = _context.v;
          _iterator8.e(_t);
        case 12:
          _context.p = 12;
          _iterator8.f();
          return _context.f(12);
        case 13:
          if (!(response.txs.length < limit)) {
            _context.n = 14;
            break;
          }
          return _context.a(2, {
            txs: Array.from(transactions.values()),
            failed: false,
            poll_latest_ts: latest
          });
        case 14:
          // A full page may end partway through a timestamp shared by several rows.
          // Re-read that boundary until a shorter page or a later timestamp proves
          // that the whole group has been fetched.
          safeAfter = latest - 1;
          if (!(safeAfter > after)) {
            _context.n = 15;
            break;
          }
          after = safeAfter;
          limit = baseLimit;
          _context.n = 17;
          break;
        case 15:
          if (!(limit < MAX_ARCHIVE_PAGE_SIZE)) {
            _context.n = 16;
            break;
          }
          limit = Math.min(MAX_ARCHIVE_PAGE_SIZE, limit * 2);
          _context.n = 17;
          break;
        case 16:
          return _context.a(2, {
            txs: [],
            failed: true
          });
        case 17:
          page++;
          _context.n = 1;
          break;
        case 18:
          return _context.a(2, {
            txs: Array.from(transactions.values()),
            failed: false,
            poll_latest_ts: after
          });
      }
    }, _callee, null, [[6, 11, 12, 13]]);
  }));
  return _queryPollPages.apply(this, arguments);
}
function loadTweetTransactions(mod, mode, callback) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (typeof callback !== 'function') {
    return;
  }
  var type = 'tweets';
  var lookup = isExactLookup(mode);
  var signature = options.sig != null ? String(options.sig) : '';
  var busyKey = lookup ? "tweets:".concat(mode, ":").concat(signature) : "tweets:".concat(mode);
  if (lookup && !signature) {
    callback(emptyResult(type, mode));
    return;
  }
  if (!mod._load_busy) {
    mod._load_busy = {};
  }
  if (mod._load_busy[busyKey]) {
    mod._load_busy[busyKey].push(callback);
    return;
  }
  var callbacks = [callback];
  mod._load_busy[busyKey] = callbacks;
  var finished = false;
  var failed = false;
  var requestVersions = new Map();
  var added = [];
  var new_tweets = [];
  var updated = [];
  var ignored = [];
  var newest_known_tweet_ts = newestKnownTweetTs(mod);
  var notify = !lookup;
  var finish = function finish(exhausted) {
    if (finished) {
      return;
    }
    finished = true;
    // A source may reopen after its response, while another peer is pending.
    var history_reopened = Array.from(requestVersions).some(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        peer_obj = _ref4[0],
        version = _ref4[1];
      return (peer_obj.tweets_history_version || 0) !== version;
    });
    var result = {
      type: type,
      direction: mode,
      added: added.slice(),
      new_tweets: new_tweets.slice(),
      updated: updated.slice(),
      ignored: ignored.slice(),
      failed: failed,
      history_reopened: history_reopened,
      exhausted: !failed && !history_reopened && Boolean(exhausted)
    };
    mod._load_busy[busyKey] = null;
    for (var _i = 0, _callbacks = callbacks; _i < _callbacks.length; _i++) {
      var cb = _callbacks[_i];
      try {
        cb(result);
      } catch (err) {
        console.error('RedSquare tweet load callback failed', err);
      }
    }
  };
  var mergeBuckets = function mergeBuckets(buckets) {
    var _iterator3 = _createForOfIteratorHelper(buckets.added),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var sig = _step3.value;
        if (!added.includes(sig)) {
          added.push(sig);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    var _iterator4 = _createForOfIteratorHelper(buckets.new_tweets),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _sig = _step4.value;
        if (!new_tweets.includes(_sig)) {
          new_tweets.push(_sig);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    var _iterator5 = _createForOfIteratorHelper(buckets.updated),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _sig2 = _step5.value;
        if (!updated.includes(_sig2)) {
          updated.push(_sig2);
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    var _iterator6 = _createForOfIteratorHelper(buckets.ignored),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _sig3 = _step6.value;
        if (!ignored.includes(_sig3)) {
          ignored.push(_sig3);
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  };
  var runPeers = function runPeers(selectionMode, peers, done) {
    if (!peers.length) {
      done(true);
      return;
    }
    var remaining = peers.length;
    var emptyCount = 0;
    var stoppedForLookup = false;
    var onPeerComplete = function onPeerComplete(peer_obj, queryType, response, historyVersion) {
      if (stoppedForLookup) {
        return;
      }
      var peerFailed = response.failed;
      var rows = response.txs;
      var updateEarliest = queryType === 'older' || queryType === 'tip';
      var updatePeerCursors = queryType !== 'lookup';
      // Commit cursors only after the entire response was processed successfully.
      var nextPeerState = _objectSpread({}, peer_obj);
      var buckets;
      if (!peerFailed) {
        try {
          buckets = processTweetTxs(mod, nextPeerState, rows, {
            updateEarliest: updateEarliest,
            updatePeerCursors: updatePeerCursors,
            updateLatest: queryType !== 'older' && queryType !== 'lookup',
            notify: notify,
            newest_known_tweet_ts: newest_known_tweet_ts,
            includeNew: queryType !== 'older' && queryType !== 'lookup'
          });
          if (queryType === 'poll') {
            nextPeerState.tweets_latest_ts = response.poll_latest_ts;
          }
          mergeBuckets(buckets);
        } catch (err) {
          peerFailed = true;
        }
      }
      if (peerFailed) {
        failed = true;
      } else {
        var currentHistory = (peer_obj.tweets_history_version || 0) === historyVersion;
        if (updatePeerCursors) {
          var reopen = currentHistory && queryType === 'poll' && peer_obj.tweets_exhausted && rows.length > 0 && (!peer_obj.tweets_has_rows || buckets.added.some(function (signature) {
            var tweet = mod.getTweet(signature);
            return tweet && !tweet.parent_id && !tweet.ephemeral;
          }));
          if (currentHistory) {
            peer_obj.tweets_earliest_ts = nextPeerState.tweets_earliest_ts;
            if (updateEarliest) {
              peer_obj.tweets_exhausted = rows.length === 0;
            }
            peer_obj.tweets_latest_ts = nextPeerState.tweets_latest_ts;
            peer_obj.tweets_hydrated = true;
          }
          if (rows.length > 0) {
            peer_obj.tweets_has_rows = true;
          }
          if (reopen) {
            reopenTweetSource(peer_obj);
          }
        }
        if (lookup && mod.hasTweet(signature)) {
          stoppedForLookup = true;
          done(false);
          return;
        }
        if (rows.length === 0 && currentHistory) {
          emptyCount++;
        }
      }
      remaining--;
      if (remaining <= 0) {
        done(emptyCount === peers.length && added.length === 0);
      }
    };
    var _iterator7 = _createForOfIteratorHelper(peers),
      _step7;
    try {
      var _loop = function _loop() {
        var peer_obj = _step7.value;
        var queryType = queryTypeForPeer(peer_obj, selectionMode);
        if (queryType === 'older' && peer_obj.tweets_exhausted) {
          remaining--;
          emptyCount++;
          if (remaining <= 0) {
            done(emptyCount === peers.length && added.length === 0);
          }
          return 1; // continue
        }
        var historyVersion = peer_obj.tweets_history_version || 0;
        if (queryType !== 'lookup') {
          requestVersions.set(peer_obj, historyVersion);
        }
        var request = queryType === 'poll' ? queryPollPages(mod, peer_obj, options) : queryPeer(mod, peer_obj, queryType, options);
        request.then(function (response) {
          onPeerComplete(peer_obj, queryType, response, historyVersion);
        });
      };
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        if (_loop()) continue;
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  };
  if (lookup && mod.hasTweet(signature)) {
    finish(false);
    return;
  }
  var selection = selectTweetSources(mod, mode, options);
  runPeers(selection.mode, selection.peers, function (exhausted) {
    // Remote history ended: check the remaining local archive before reporting
    // exhaustion to the manager.
    if (mode === 'older' && exhausted && !failed) {
      var local = localPeer(mod);
      if (local && !local.tweets_exhausted && !selection.peers.includes(local)) {
        runPeers('older', [local], function (localExhausted) {
          finish(exhausted && localExhausted);
        });
        return;
      }
    }

    // Remote tip produced no timeline roots: localhost is a fallback, never the
    // default just because the archive happens to be populated.
    if (!lookup && mode === 'newer' && !hasUsableTimelineContent(mod) && remotePeers(mod).length > 0) {
      var _local = localPeer(mod);
      if (_local && !selection.peers.includes(_local)) {
        runPeers('tip', [_local], function (localExhausted) {
          finish(exhausted && localExhausted);
        });
        return;
      }
    }
    finish(exhausted);
  });
}
module.exports = {
  LIVE_TWEET_WINDOW_MS: LIVE_TWEET_WINDOW_MS,
  isLocalPeer: isLocalPeer,
  remotePeers: remotePeers,
  localPeer: localPeer,
  createPeerState: createPeerState,
  reopenTweetSource: reopenTweetSource,
  hasUsableTimelineContent: hasUsableTimelineContent,
  noteLocalSyncedTweet: noteLocalSyncedTweet,
  isExactLookup: isExactLookup,
  selectTweetSources: selectTweetSources,
  queryTypeForPeer: queryTypeForPeer,
  emptyResult: emptyResult,
  loadTweetTransactions: loadTweetTransactions
};